
export const SMALL_BREAK_POINT = 500;
export const MEDIUM_BREAKPOINT = 768;

const docElement = document.documentElement;
const docBody = document.body;

let screenWidth = 0;
let screenHeight = 0;
let screenMinSize = 0;
let screenMaxSize = 0;

export default {
    isSmall(){
        return screenMinSize <= SMALL_BREAK_POINT;
    },
    isMedium(){
        return screenMinSize > SMALL_BREAK_POINT && screenMinSize <= MEDIUM_BREAKPOINT;
    },
    isLarge(){
        return screenMinSize > MEDIUM_BREAKPOINT;
    }
};

function handleResize() {
    screenWidth = window.screen && window.screen.width || window.innerWidth || docElement && docElement.clientWidth || docBody.clientWidth || 0;
    screenHeight = window.screen && window.screen.height || window.innerHeight || docElement && docElement.clientHeight || docBody.clientHeight || 0;

    screenMinSize = Math.min(screenWidth, screenHeight);
    screenMaxSize = Math.max(screenWidth, screenHeight);
}

$(window).resize(handleResize);
handleResize();



// WEBPACK FOOTER //
// ./assets/es6/common/screen.es6